import * as validators from '@vuelidate/validators'
import * as customValidators from './../shared/customValidators'
import i18n from '@/i18n/index'

const { createI18nMessage } = validators

const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n) })

export const required = withI18nMessage(validators.required)
export const requiredIf = withI18nMessage(validators.requiredIf, { withArguments: true })
export const email = withI18nMessage(validators.email)
export const phoneNumberPattern = withI18nMessage(customValidators.phoneNumberPattern, { withArguments: true })
export const passwordPattern = withI18nMessage(customValidators.passwordPattern)
export const numberArrayPattern = withI18nMessage(customValidators.numberArrayPattern)
export const sameAs = withI18nMessage(validators.sameAs, { withArguments: true })
export const minLength = withI18nMessage(validators.minLength, { withArguments: true })
export const maxLength = withI18nMessage(validators.maxLength, { withArguments: true })
export const minValue = withI18nMessage(validators.minValue, { withArguments: true })
export const appointmentEndTimeGreaterThan = withI18nMessage(customValidators.appointmentEndTimeGreaterThan, { withArguments: true })
export const maxBarcode = withI18nMessage(customValidators.maxBarcode)
export const isAfterDate = withI18nMessage(customValidators.isAfterDate, { withArguments: true })
